import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Grid3x3Icon(props: IconProps) {
    return <Icon {...props} iconKey={"grid_3x3"}/>
}
